import { Link } from "@tanstack/react-router"
import { Avatar } from "~/components/ui/avatar"
import { UnreadDot } from "~/components/unread-dot"
import { useUnreadCount } from "~/features/profile/hooks/use-unread-count"
import { useUser } from "~/features/profile/hooks/use-user"

export function UserDisplay() {
  const { data: user } = useUser()
  const { data: unreadCount } = useUnreadCount()

  if (!user) return null

  return (
    <Link to="/" search={{ tab: "profile" }} className="flex items-center gap-s min-w-0">
      <div className="leading-relaxed font-semibold text-right min-w-0">
        <div className="text-base font-semibold truncate">{user.name?.split(" ")[0]}</div>
        {user.roleLabel && <div className="text-secondary-foreground">{user.roleLabel}</div>}
      </div>
      <div className="relative shrink-0">
        <Avatar url={user.avatar?.url} name={user.name} className="size-header-icon border-2 border-primary/30" />
        {unreadCount > 0 && <UnreadDot className="absolute top-0 right-0 size-3" />}
      </div>
    </Link>
  )
}

export function UserDisplaySkeleton() {
  return <div className="size-header-icon rounded-full bg-muted animate-pulse" />
}
